// src/components/MenuGrid.jsx
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

function MenuGrid({ items }) {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="menu-grid">
      {items.map((item) => (
        <div className="menu-card" key={item.id}>
          <img src={item.img} alt={item.name} />

          <h3>{item.name}</h3>
          <p className="menu-desc">{item.desc}</p>

          <div className="menu-bottom">
            <p className="menu-price">${item.price.toFixed(2)}</p>

            <button className="add-btn" onClick={() => addToCart(item)}>
              Add
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MenuGrid;
